import { ApplicationManufacturer } from "./_models";
import { IWebApplicationManufacturer, IWebPhase0Model } from "./_webmodels";

export const applicationTerminationStates = {
  REQUEST_TERMINATE_APPLICATION : {
    code: 'Request',
    state: 'Application Termination Requested',
    icon: '/media/icons/duotune/arrows/arr076.svg'        
  },
  REQUEST_TERMINATE_APPLICATION_REPLY : {
    code: 'Replied',
    state: 'Application Termination RFI',
    icon: '/media/icons/duotune/communication/com007.svg'        
  },    
  COMPLETED : {
    code: 'Completed',
    state: 'Application Termination Completed',
    icon: '/media/icons/duotune/arrows/arr061.svg'   // X box   //  '/media/icons/duotune/arrows/arr085.svg' // check mark
  },    
  FAILED : {
    code: 'Failed',
    state: 'Application Termination Failed',
    icon: null, 
  },    
}

export const applicationEditStates = {
  REQUEST_EDIT_APPLICATION : {
    code: 'Request',
    state: 'Application Edit Requested',
    icon: '/media/icons/duotune/general/gen055.svg'        
  },
  REQUEST_EDIT_APPLICATION_REPLY : {
    code: 'Replied',
    state: 'Application Edit RFI',
    icon: '/media/icons/duotune/communication/com007.svg'        
  },    
  COMPLETED : {
    code: 'Completed',
    state: 'Application Edit Completed',
    icon: '/media/icons/duotune/arrows/arr061.svg'   // X box   //  '/media/icons/duotune/arrows/arr085.svg' // check mark
  },    
  FAILED : {
    code: 'Failed',
    state: 'Application Edit Failed',
    icon: null, 
  },    
}


export const reassignAppStates = [    
  { state : 'Admin Review', role : 'CAMS Admin'},
  { state : 'Draft Quotation', role : 'CAMS Quotation Admin'},    
  { state : 'Quotation Approved', role : 'CAMS Admin'},
  { state : 'Inspector Review', role : 'CAMS Inspector'},
  { state : 'Inspector Reviewer Review', role : 'CAMS Second Reviewer'},  //  except the one that did the review
  { state : 'Inspector Reviewer Review - Issue', role : 'CAMS Inspector'}, //  except the current reviewer
  { state : 'Program Manager Review', role : 'CAMS Program Manager'},
  { state : 'Inspection Process - Admin Setup', role : 'CAMS Admin'},
  { state : 'Inspection Process - Inspection', role : 'CAMS Inspector'},
  { state : 'Inspection Process - Issue Review', role : 'CAMS Inspector'},
  { state : 'Committee Review - Admin Setup', role : 'CAMS Admin'},
  // "Committee Review - Review Process"" - TBD. but should not have reassign.
  { state : 'Committee Review - Program Manager', role : 'CAMS Program Manager'},
  { state : 'Program Manager Approval', role : 'CAMS Program Manager'},
  { state : 'Applicant Confirmation - Admin Setup', role : 'CAMS Admin'},
  { state : 'Applicant Confirmation - Draft Certificate', role : 'CAMS Admin'},
  { state : 'Applicant Confirmation - Draft Rejected', role : 'CAMS Admin'},
  { state : 'Applicant Confirmation - Draft Approved', role : 'CAMS Admin'},
  { state : 'Program Manager Rejected (A)', role: 'CAMS Admin'},
  { state : 'Program Manager Rejected (I)', role: 'CAMS Inspector'},  
  // Inspection Process - Inspection substates
  { state : 'Inspection - Inspection Kit', role : 'CAMS Inspector'},
  { state : 'Inspection - Sampling', role : 'CAMS Inspector'},
  { state : 'Inspection - CoC', role : 'CAMS Inspector'},
  { state : 'Issue - CoC', role : 'CAMS Admin'},
];


export const APPLICATION_NOEDIT_STATES = [
  'Draft',
  'DRAFT',
  'Admin Review - Issue',
  'Applicant Signed',
  'Applicant Confirmation',
  "Applicant Confirmation - Admin Setup",
  "Applicant Confirmation - Draft Rejected",
  "Applicant Confirmation - Pending Draft Approval",
  "Applicant Confirmation - Draft Approved",  
  'Completed',
  'Failed',
  'Terminated',
  'Withdrawn',
  'TERMINATED',
  'COMPLETED',
  'FAILED',
  'WITHDRAWN'
];


export const initWebApplicationManufacturerValues: IWebApplicationManufacturer = {
  id: 0,
  manufacturerName: '',
  manufacturerAddress: '',
  manufacturerPerson: '',
  manufacturerPersonDesignation: '',
  manufacturerTel: '',
  manufacturerFax: '',
  manufacturerEmail: '',
  manufacturerWebsite: '',
  manufacturerLetterAttachment: 0,
  manufacturerLetterAttachmentAttachmentName: '',
}

export const initApplicationManufacturerValues : ApplicationManufacturer = {
  id: 0,
  manufacturerName:	'',
  manufacturerAddress:	'',
  manufacturerPerson:	'',
  manufacturerPersonDesignation:	'',
  manufacturerTel:	'',
  manufacturerFax:	'',
  manufacturerEmail:	'',
  manufacturerWebsite:	'',
  //@ts-ignore
  manufacturerLetterAttachment:	null,
  manufacturerNameChanged:	false,
  manufacturerAddressChanged:	false,
  manufacturerPersonChanged:	false,
  manufacturerPersonDesignationChanged:	false,
  manufacturerTelChanged:	false,
  manufacturerFaxChanged:	false,
  manufacturerEmailChanged:	false,
  manufacturerWebsiteChanged:	false,
  manufacturerLetterAttachmentChanged:	false,
};

export const APPLICATION_MANUFACTURER_FIELDS = [    
'manufacturerName',
'manufacturerAddress',
'manufacturerPerson',
'manufacturerPersonDesignation',
'manufacturerTel',
'manufacturerFax',
'manufacturerEmail',
'manufacturerWebsite',
'manufacturerLetterAttachment',
'manufacturerNameChanged',
'manufacturerAddressChanged',
'manufacturerPersonChanged',
'manufacturerPersonDesignationChanged',
'manufacturerTelChanged',
'manufacturerFaxChanged',
'manufacturerEmailChanged',
'manufacturerWebsiteChanged',
'manufacturerLetterAttachmentChanged',
];


export const applicationInitValues: IWebPhase0Model = {
  id: 0,
  isClientManager: false,
  applicationType: 'NEW',
  productType: 0,
  scheme: 0,
  schemeName: '', 
  companyId: 0,
  companyName: '',
  companyAddress: '',
  companyPerson: '',
  companyPersonDesignation: '',
  companyTel: '',
  companyFax: '',
  companyEmail: '',
  companyWebsite: '',
  companyAcraAttachment: 0,
  companyAcraAttachmentName: '',

  isoAttachment: [],
  isoFileAttachments: [],
  manufacturers: [
    { ...initWebApplicationManufacturerValues }      
  ],
  transfer: false,
  transferAttachment: 0,
  transferAttachmentName: '',
  productCategory: 0,
  productCategoryString: '',
  productBrand: '',
  productModel: '',
  productOrigin: '',
  productDetails: '',

  productAttachment: [],
  productFileAttachments: [],

  tests: [],
  assessments: [],
  fromCertificate: 0,
  checklistFile: 0,
  tncFile: 0,

  note: '',           
  comment: '',

  checklistFileId: 0,

  tncFileId: 0,
  
  confirm: false,
}

